import React, { useState, useEffect } from "react";
// import marketnamedata from './MarketNamedata';
import * as Icon from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { Carousel } from "antd";
import chaticon from "../assets/img/chaticon.png";
import withdrawchat from "../assets/img/withdrawchat.png";
import downloadbutton from "../assets/img/downloadbutton.png";
import iconbabaji from "../assets/img/logo.png";
import jQuery from "jquery";
import axios from "axios";
import logo from "../assets/img/logo.png";
import Trident from "../assets/img/trident.png";
import ReactHtmlParser from "react-html-parser";


import colorGame from "../assets/img/home/wingo_btn.png";
import AviatorGame from "../assets/img/home/aviator_btn.png";
import CricketGame from "../assets/img/home/cricket.png";

export default function Home() {
  const initialTime = 15 * 60; // 15 minutes in seconds
  const [countdown, setCountdown] = useState(initialTime);
  const [isRunning, setIsRunning] = useState(false);
  const [users, setUsers] = useState([]);
  const [users1, setUsers1] = useState([]);
  const [usersdata, setUsersdata] = useState([]);
  const [datamsg, setDataMsg] = useState([]);
  const [marketdetails, setmarketdetails] = useState([]);
  const [depositCountData, setdepositCount] = useState([]);
  const [withdrawCountData, setwithdrawCount] = useState([]);
  const [data, setData] = useState("Your data here");
  const clearData = () => {
    setData("");
  };

  useEffect(() => {
    let timer;
    if (isRunning && countdown > 0) {
      timer = setInterval(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      clearInterval(timer);
    }
    return () => {
      clearInterval(timer);
    };
  }, [isRunning, countdown]);

  const startCountdown = () => {
    setIsRunning(true);
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  const contentStyle = {
    height: "70px",
  };

  useEffect(() => {
    loaduser();
    depositCount();
  }, []);

  const dev_id = localStorage.getItem("dev_id");
  const loaduser = async () => {
    const user_id = localStorage.getItem("userid");
    let url = `${process.env.REACT_APP_API_URL_NODE}home`;

    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
      user_id: user_id,
      dev_id: dev_id,
    };

    var config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();
      // console.warn(data.marquee_msg)
      setDataMsg(data);
      setmarketdetails(data);
      // Handle the response data as needed
      const objectRes = data;

      const objectRess = objectRes.data;
      // console.warn(objectRess)
      setUsers(objectRess);
      setUsersdata(objectRess);

      // console.warn(objectRess);

      loaduser1();
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const depositCount = async () => {
    const user_id = localStorage.getItem("userid");
    // let url = `${process.env.REACT_APP_API_URL_NODE}unseen-chat-count`;
    let url = `https://api.khelomatka.com/api/users/unseen-chat-count`;

    const requestData = {
      user_id: user_id,
    };

    var config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();
      setdepositCount(data.message.desposit);
      setwithdrawCount(data.message.withdraw);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const viewBroadcast = async () => {
  //   const user_id = localStorage.getItem("userid");
  //   const apiUrl = `${process.env.REACT_APP_API_URL_NODE}view-boardcast`;
  //   const requestData = {
  //     app_id: process.env.REACT_APP_API_ID,
  //     user_id: user_id,
  //     broadcast_id: users1.id,
  //   };

  //   fetch(apiUrl, {
  //     method: "POST",
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify(requestData),
  //   })
  //   loaduser1();
  // };

  const viewBroadcast = async () => {
    try {
      const user_id = localStorage.getItem("userid");
      const apiUrl = `${process.env.REACT_APP_API_URL_NODE}view-boardcast`;
      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        broadcast_id: users1.id,
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      console.warn(response);

      if (response.status == 200) {
        loaduser1();
      } else {
        console.error("Failed to view broadcast:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleClick = (id, name) => {
    window.location.href = `/Playgame?id=${id}&name=${name}`;
  };

  const loaduser1 = async () => {
    const user_id = localStorage.getItem("userid");
    // alert(user_id);
    try {
      const url = `${process.env.REACT_APP_API_URL_NODE}latest-boardcast`;
      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
      };
      var config = {
        method: "POST",
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      };
      axios.post(url, requestData, config).then(function (response) {
        const res = JSON.stringify(response.data.data);
        const objectRes = JSON.parse(res);
        setUsers1(objectRes[0]);
        // if (objectRes.length > 0) {
        //   jQuery("#modal-container").removeAttr("class").addClass("five");
        //   jQuery("body").addClass("modal-active");
        // }
      });
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    }
  };

  jQuery(function () {
    jQuery("#clickme").click(function () {
      var buttonId = jQuery(this).attr("id");
      jQuery("#modal-container").removeAttr("class").removeClass(buttonId);
      jQuery("body").removeClass("modal-active");

      // jQuery(this).addClass('out');
    });
    jQuery("#closemodle").click(function () {
      var buttonId = jQuery(this).attr("id");
      jQuery("#modal-container").removeAttr("class").removeClass(buttonId);
      jQuery("body").removeClass("modal-active");

      // jQuery(this).addClass('out');
    });
  });
  function refreshPage() {
    setTimeout(() => {
      window.location.reload(false);
    }, 500);
    console.log("page to reload");
  }
  // const loginChk = async (e) => {
  //   setLoading1(true);

  //   let url = `${process.env.REACT_APP_API_URL_NODE}login-chkotp-new`;
  //   const requestData = {
  //     mob: mobile,
  //     otp: otpnumbers,
  //   };

  //   const config = {
  //     method: "POST",
  //     url: url,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: requestData,
  //   };

  //   axios(config).then(function (response) {
  //     if (response.data.success == 1) {
  //       const MySwal = withReactContent(Swal);
  //       MySwal.fire({
  //         title: "Login Successfully",
  //         icon: "success",
  //         timer: 2000,
  //       }).then((result) => {
  //         setOtpsend(response.data.otp);
  //         setuser_id(response.data.user_id);
  //         settoken(response.data.token);
  //         settokenone(response.data.tokenl);
  //         setdev_id(response.data.device_id);

  //         localStorage.setItem("userid", response.data.user_id);
  //         localStorage.setItem("dev_id", response.data.device_id);
  //         localStorage.setItem("token", response.data.token);
  //         localStorage.setItem("tokenl", response.data.tokenl);

  //         navigate("/Home");
  //       });
  //     } else {
  //       setLoading1(false);
  //       const MySwal = withReactContent(Swal);
  //       MySwal.fire({
  //         title: "Invalid Otp",
  //         icon: "error",
  //         timer: 2000,
  //       });
  //     }
  //   });
  // };
  const [loginHome, setHomeTitle] = useState("");
  useEffect(() => {
    loaduser11();
  }, []);
  const loaduser11 = async () => {
    let url = `${process.env.REACT_APP_API_URL_NODE}basic-details`;

    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
    };

    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();
      // console.log(data);

      const basicdet = data.data.home_page_title;
      // console.warn("oppppp", basicdet);
      localStorage.setItem("ref_status", data.data.ref_status);
      setHomeTitle(data.data.home_page_title);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const btnStyle = {
  padding: "3px",
  margin: "6px",
  borderRadius: "14px",
  background:
    "conic-gradient(from var(--angle), transparent 0deg, transparent 250deg, #00f2ff 300deg, #ffffff 330deg, #ff00ea 360deg)",
  animation: "runLight 3s linear infinite",
  boxShadow: "0 0 12px rgba(0, 242, 255, 0.5)",
};

const linkStyle = {
  display: "block",
  borderRadius: "12px",
  overflow: "hidden",
  // background: "#000",
};

const imgStyle = {
  display: "block",
  width: "100%",
  borderRadius: "12px",
};
  return (
    <>

     {/* Animation ke liye (inline style mein keyframes nahi likh sakte) */}
    <style>{`
      @property --angle {
        syntax: "<angle>";
        initial-value: 0deg;
        inherits: false;
      }
      @keyframes runLight {
        to { --angle: 360deg; }
      }
    `}</style>
      <div className="popupnew" id="modal-container">
        <div className="new_five">
          <div className="modal-background position-relative">
            <div className="modal">
              <button onClick={viewBroadcast} id="closemodle">
                &times;
              </button>
              <div className="logo_babaji">
                <img src={logo} alt="" />
              </div>
              <h2 className="updateversion">{users1 && users1.title}</h2>
              <p className="updateversion_sec">
                {ReactHtmlParser(users1 && users1.message)}
                {users1 && users1.type == "video" ? (
                  <video controls width="100%" height="150px">
                    <source src={users1.media} />
                  </video>
                ) : (
                  <></>
                )}
                {users1 && users1.type == "image" ? (
                  <img
                    src={users1.media}
                    alt="User"
                    style={{ width: "50px" }}
                  />
                ) : (
                  <></>
                )}
              </p>
              <div className="btn-group">
                <Link
                  to="/Notification"
                  className="btnnew btn-masterful"
                  id="clickme"
                >
                  <span className="icon">&#x1F680;</span>
                  <span onClick={viewBroadcast} className="btn-txt">
                    Click me!
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="five" className="button"></div>

      <div className="mainhome">
        <div className="bg_home margin-bottom-88">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 p-0 col-5 mb-2">
                <div className="button_chat">
                  <button className="d-flex gap-2 align-items-center">
                    <Link to="/Depositchat">
                      <div>
                        <i class="bi bi-chat-dots"></i>
                        {depositCountData == 0 ? (
                          // <span className="badge notibadge text-center bedgecustum">
                          //   <span>11</span>
                          // </span>
                          <></>
                        ) : (
                          <span className="badge notibadge text-center bedgecustum">
                            <span>{depositCountData}</span>
                          </span>
                        )}
                      </div>
                      Deposit Chat
                    </Link>
                  </button>
                </div>
                <div className="withdrawbutton_chat">
                  <button className="d-flex gap-2 align-items-center">
                    <Link to="/Withdrawalchat">
                      <div>
                        <i class="bi bi-chat-dots"></i>
                        {withdrawCountData == 0 ? (
                          // <span className="badge notibadge text-center bedgecustum">
                          //   <span>11</span>
                          // </span>
                          <></>
                        ) : (
                          <span className="badge notibadge text-center bedgecustum">
                            <span>{withdrawCountData}</span>
                          </span>
                        )}
                      </div>
                      Withdraw Chat
                    </Link>
                  </button>
                </div>
              </div>
              <div className="col-md-4 p-0 col-3">
                <div className="logofront">
                  <img
                    src={iconbabaji}
                    className="mx-auto d-flex justify-content-end"
                  />
                </div>
              </div>
              <div className="col-md-4 p-0 col-4">
                <div className="othergames position-relative">
                  <Link
                    to={
                      marketdetails.current_market_details &&
                      marketdetails.current_market_details.other_game
                    }
                    target="_blank"
                    className="position-relative"
                  >
                    Other Game
                    <span className="new-badge">NEW</span>
                  </Link>
                </div>

                <div className="cleardata">
                  <Link onClick={refreshPage}>Refresh</Link>
                </div>
              </div>
            </div>
          </div>


       


<div className="row">
  {/* Color Game - Always Show */}
  <div className="col-md-4 col-12 px-0">
    <div style={btnStyle}>
      <a
        href={marketdetails?.colorGameONOFF === "1" ? "/colorgame" : undefined}
        className="color-game-btn"
        style={{
          ...linkStyle,
          cursor: marketdetails?.colorGameONOFF === "1" ? "pointer" : "not-allowed",
        }}
        onClick={(e) => {
          if (marketdetails?.colorGameONOFF !== "1") {
            e.preventDefault();
          }
        }}
        aria-disabled={marketdetails?.colorGameONOFF !== "1"}
      >
        <img src={colorGame} alt="Color Game" style={imgStyle} />
      </a>
    </div>
  </div>

  {/* Aviator Game - Always Show */}
  <div className="col-md-4 col-6 px-0">
    <div style={btnStyle}>
      <a
        href={marketdetails?.aviatorGameONOFF === "1" ? "/aviatorGame" : undefined}
        className="color-game-btn"
        style={{
          ...linkStyle,
          cursor: marketdetails?.aviatorGameONOFF === "1" ? "pointer" : "not-allowed",
        }}
        onClick={(e) => {
          if (marketdetails?.aviatorGameONOFF !== "1") {
            e.preventDefault();
          }
        }}
        aria-disabled={marketdetails?.aviatorGameONOFF !== "1"}
      >
        <img src={AviatorGame} alt="Aviator Game" style={imgStyle} />
      </a>
    </div>
  </div>

  {/* Cricket Game - Always Show */}
  <div className="col-md-4 col-6 px-0">
    <div style={btnStyle}>
      <a
        href={
          marketdetails?.aviatorGameONOFF === "1"
            ? marketdetails?.current_market_details?.other_game || undefined
            : undefined
        }
        target="_blank"
        rel="noopener noreferrer"
        className="color-game-btn"
        style={{
          ...linkStyle,
          cursor:
            marketdetails?.aviatorGameONOFF === "1" &&
            marketdetails?.current_market_details?.other_game
              ? "pointer"
              : "not-allowed",
        }}
        onClick={(e) => {
          if (
            marketdetails?.aviatorGameONOFF !== "1" ||
            !marketdetails?.current_market_details?.other_game
          ) {
            e.preventDefault();
          }
        }}
        aria-disabled={
          marketdetails?.aviatorGameONOFF !== "1" ||
          !marketdetails?.current_market_details?.other_game
        }
      >
        <img src={CricketGame} alt="Cricket Game" style={imgStyle} />
      </a>
    </div>
  </div>
</div>



          {users && (
            <marquee className="resultmarquee" behavior="" direction="">
              {datamsg.marquee_msg}
            </marquee>
          )}
          <div className="card card-style cardbabaji">
            <div className="content">
              <center>
                <h6 className="mt-1">&#128293; ALL IS WELL &#128293; </h6>
                <h6> &#128591; GOD IS GREAT &#128591; </h6>
              </center>
              <h6 className="d-flex justify-content-center">
                <span id="date">
                  {datamsg.nformat}
                  {/* <div>{new Date(users.nformat).toLocaleDateString()}</div>
                  <div>{new Date(users.nformat).toLocaleTimeString()}</div> */}
                  <date />
                </span>
                {/* <span id="time">14:22</span> */}
              </h6>
            </div>
          </div>
      <div className="d-flex justify-content-center">
      

<div className="animated-box todayresultdesign in my-2" style={{ width: "100%" }}>
  <div className="card card-style" style={{ width: "100%" }}>
    <p
      style={{
        textAlign: "center",
        backgroundColor: "yellow",
        color: "#000000",
        padding: "11px",
        fontSize: "16px",
        fontWeight: "500",
        margin: 0,
        borderRadius: "6px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      अगर आप अपने रेफरल से किसी व्यक्ति को जोड़ते हैं, तो उसकी बेट
      (bet) का 5% आपको बोनस के रूप में मिलेगा।
    </p>
  </div>
</div>

          </div>
          <div className="d-flex w-100 justify-content-center">
            <div class="animated-box in my-2 w-100">
              <div className="card card-style">
                <center>
                  {marketdetails && (
                    <div className="result align-items-center">
                      <div className="px-3">
                        <img
                          src={Trident}
                          alt="Trident"
                          className="img-fluid"
                        />
                      </div>
                      <h6>
                        <p className="text-danger fs-4 mb-2">Result</p>
                        <p className="fw-bold mb-1">
                          {marketdetails.current_market_details &&
                            marketdetails.current_market_details.market_name}
                        </p>
                        <span className="fw-bold">
                          {marketdetails.current_market_details &&
                            marketdetails.current_market_details.market_result}
                        </span>
                      </h6>
                      <div className="px-3">
                        <img
                          src={Trident}
                          alt="Trident"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  )}
                </center>
              </div>
            </div>
          </div>

          {/* <div className="card text-center clickresult1 animated-box">
            <p className="mb-0">
              &#128293; इस एप्लीकेशन मैं केवल इन वेबसाइटों के Result ही मान्य
              होंगे &#128293;
            </p>
            <Link to="/ResultPage" className="buttonclicknew" id="neonShadow">
              Click here to view websites
            </Link>
          </div> */}
          <div className="card text-center clickresult animated-box">
            <p className="mb-0">
              &#128293; सबसे पहले रिजल्ट देखने के लिए क्लिक करे &#128293;
            </p>
            <Link
              to="https://satta-king-fixed-no.in"
              className="clicklink clicknewlink"
              id="neonShadow"
            >
              Click Link
            </Link>
          </div>
          {/* <div className="card text-center clickresult animated-box">
            <p className="mb-0">
              &#128293;एप्लिकेशन डाउनलोड करने के लिए नीचे दिए गए बटन पर क्लिक
              करें। &#128293;
            </p>
            <Link
              to="https://rpk90.com/apk/RPK90-V1.apk"
              className="clicklink downloadapk"
              id="neonShadow "
            >
              Download Apk
             
            </Link>
          </div> */}
          {/* <div className="card live-result">
            <p>
              <strong>Note</strong>
            </p>
            <p>{ReactHtmlParser(datamsg.note)}</p>
            <p>
          
              {loginHome}
            </p>
          </div> */}
          <div className="card matkalive-result">
            <p>rpk90 Matka Live Result of {marketdetails.current_date}</p>
          </div>
          <table className="marketnametime">
            <thead>
              <tr>
                <td className="width_50">Market Name/Time</td>
                <td className="width_25">Previous Result</td>
                <td className="width_25 border-radius">Today Result</td>
              </tr>
            </thead>
          </table>
          {usersdata &&
            usersdata.map((user) =>
              user.is_open == 1 ? (
                <div
                  className="market"
                  onClick={() => {
                    handleClick(user.market_id, user.market_name);
                  }}
                >
                  {/* <div className="market"> */}
                  <div className="d-flex justify-content-between align-items-end">
                    <div className="marketnamelist" style={{ width: "70%" }}>
                      <h3 className="animationtittle markettitlename">
                        {user.market_name}
                      </h3>

                      <ul className="liststyle">
                        <li>
                          Open Time
                          <span className="d-block">{user.openTime}</span>
                        </li>
                        <li>|</li>
                        <li>
                          Close Time
                          <span className="d-block">{user.closeTime}</span>
                        </li>
                        <li>|</li>
                        <li>
                          Result At{" "}
                          <span className="d-block">{user.resultTime}</span>
                        </li>
                      </ul>
                    </div>
                    <div className="d-flex">
                      <div
                        className="text-center"
                        onClick={startCountdown}
                        disabled={isRunning}
                      >
                        {/* <Icon.ChevronRight /> */}
                        <h3 className="mb-0 text-white">
                          {user.market_result_previous_day}
                        </h3>
                      </div>
                      &nbsp; &nbsp; &nbsp;
                      <div
                        className="text-center"
                        onClick={startCountdown}
                        disabled={isRunning}
                      >
                        {/* <Icon.ChevronRight /> */}
                        <h3 className="mb-0 text-white">
                          {user.market_result}
                        </h3>
                      </div>
                    </div>
                    {/* <div className="text-center playicon" onClick={startCountdown} disabled={isRunning}>
                  <Icon.ChevronRight />

                </div> */}
                  </div>
                </div>
              ) : (
                <div className="market">
                  {/* <div className="market"> */}
                  <div className="d-flex justify-content-between align-items-end">
                    <div className="marketnamelist" style={{ width: "70%" }}>
                      <h3 className="animationtittle markettitlename">
                        {user.market_name}
                      </h3>

                      <ul className="liststyle">
                        <li>
                          Open Time
                          <span className="d-block">{user.openTime}</span>
                        </li>
                        <li>|</li>
                        <li>
                          Close Time
                          <span className="d-block">{user.closeTime}</span>
                        </li>
                        <li>|</li>
                        <li>
                          Result At{" "}
                          <span className="d-block">{user.resultTime}</span>
                        </li>
                      </ul>
                    </div>
                    <div className="d-flex">
                      <div
                        className="text-center"
                        onClick={startCountdown}
                        disabled={isRunning}
                      >
                        {/* <Icon.ChevronRight /> */}
                        <h3 className="mb-0 text-white">
                          {user.market_result_previous_day}
                        </h3>
                      </div>
                      &nbsp; &nbsp; &nbsp;
                      <div
                        className="text-center"
                        onClick={startCountdown}
                        disabled={isRunning}
                      >
                        {/* <Icon.ChevronRight /> */}
                        <h3 className="mb-0 text-white">
                          {user.market_result}
                        </h3>
                      </div>
                    </div>
                    {/* <div className="text-center playicon" onClick={startCountdown} disabled={isRunning}>
                  <Icon.ChevronRight />

                </div> */}
                  </div>
                </div>
              ),
            )}
        </div>
      </div>
    </>
  );
}
